

export const SHOP_STATUS_ACTIVE = 1;
export const SHOP_STATUS_INACTIVE = 0;
export const SHOP_STATUS_PENDING = 2;

export const SHOP_STATUS_OPTIONS = [
  { value: SHOP_STATUS_ACTIVE, label: "Active" },
  { value: SHOP_STATUS_INACTIVE, label: "Inactive" },
  { value: SHOP_STATUS_PENDING, label: "Pending" },
];

export const resolveShopActive = (row: any): boolean => {
  if (!row) return false;

  if (row.shopStatus !== undefined && row.shopStatus !== null) {
    return Number(row.shopStatus) === SHOP_STATUS_ACTIVE;
  }

  const candidates = [row.isActive, row.active, row.enabled, row.isEnabled];
  for (const val of candidates) {
    if (val === undefined || val === null) continue;
    if (typeof val === "boolean") return val;
    if (typeof val === "number") return val === 1;
    if (typeof val === "string") {
      const normalized = val.trim().toLowerCase();
      if (["true", "1", "active", "enabled", "yes"].includes(normalized)) return true;
      if (["false", "0", "inactive", "disabled", "no"].includes(normalized)) return false;
    }
  }

  return true;
};

export const shopStatusLabel = (row: any): string => {
  const statusVal = row?.shopStatus;
  const match = SHOP_STATUS_OPTIONS.find((o) => o.value === Number(statusVal));
  if (match) return match.label;
  return resolveShopActive(row) ? "Active" : "Inactive";
};
